{
  "NO_MERCHANT": { "message": "No shop found. Please sign out and sign in again." },
  "CANNOT_MODIFY_OWNER": { "message": "The shop owner's permissions can't be changed" },
  "CANNOT_MODIFY_SELF": { "message": "You can't change your own permissions" },
  "CANNOT_REMOVE_OWNER": { "message": "The shop owner can't be removed from the team" },
  "CANNOT_REMOVE_SELF": { "message": "You can't remove yourself from the team" },
  "SUBSCRIPTION_EXPIRED": {
    "title": "Plan expired",
    "message": "Subscribe to keep using Sight Order",
    "actionLabel": "Buy a plan"
  },
  "ADDON_REQUIRES_PAID_PLAN": { "message": "You need a paid plan before buying extra seats" },
  "ADDON_QTY_DECREASE_NOT_ALLOWED": {
    "message": "Extra seats can't be reduced at renewal. Choose the same number or more."
  },
  "NO_REMAINING_TERM": { "message": "You need a paid plan before buying extra seats" },
  "IDEMPOTENCY_KEY_MISMATCH": { "message": "Your cart changed. Please try again." },
  "TOO_MANY_PENDING_ORDERS": {
    "title": "Order awaiting payment",
    "message": "Pay or cancel your outstanding order before creating a new one",
    "actionLabel": "View orders"
  },
  "PENDING_ORDER_EXISTS": {
    "title": "Order awaiting payment",
    "message": "Pay or cancel your outstanding order before creating a new one",
    "actionLabel": "View orders"
  },
  "PERSIST_FAILED": {
    "title": "We couldn't save your order",
    "message": "Our team has been notified. Please don't pay again."
  },
  "PAYMENT_PROVIDER_ERROR": { "message": "The payment service is having trouble. Please try again shortly." },
  "INVALID_TOTAL": { "message": "That order total isn't valid" },
  "RECEIPT_PROFILE_REQUIRED": { "message": "Please fill in your receipt details before paying" },
  "RATE_LIMITED": { "message": "Too many uploads. Please wait a moment." },
  "QUOTA_EXCEEDED": {
    "title": "Image limit reached for your plan",
    "message": "Upgrade your plan for more capacity, or delete older images",
    "actionLabel": "Upgrade plan"
  },
  "INVALID_FILE_TYPE": { "message": "That file isn't a supported image (PNG, JPEG, WEBP or GIF only)" },
  "PAYLOAD_TOO_LARGE": { "message": "That file is too large (1 MB maximum)" },
  "IMAGE_DIMENSIONS_TOO_LARGE": { "message": "That image is too large (25 megapixels maximum)" },
  "UPLOAD_FAILED": { "message": "The upload failed. Please try again." },
  "MERCHANT_CHANNEL_LIMIT": {
    "message": "This platform already has one active channel. Disable it before connecting another."
  },
  "SELECT_ONE_PAGE_FIRST": { "message": "Please grant exactly one Facebook Page" },
  "SELECT_ONE_ACCOUNT_FIRST": { "message": "Please grant exactly one Instagram account" },
  "LINE_TOKEN_INVALID": { "message": "That LINE Access Token isn't valid" },
  "MISSING_ACCESS_TOKEN": { "message": "No access token found" },
  "FB_NO_PAGES": { "message": "No Facebook Page was authorised for connection" },
  "IG_NO_ACCOUNTS": { "message": "No Instagram Business account was authorised for connection" },
  "INVALID_STATE": { "message": "That authorisation wasn't valid. Please start again." },
  "UNSUPPORTED_PLATFORM": { "message": "That platform isn't supported yet" },
  "CHANNEL_NOT_FOUND": { "message": "Channel not found" },
  "CHANNEL_REAUTH_REQUIRED": { "message": "This channel has lost its connection. Reconnect it in settings." },
  "CHANNEL_INACTIVE": { "message": "This channel is disabled. Enable it in channel settings." },
  "TOKEN_CHECK_FAILED": { "message": "We couldn't check this channel's status. Please try again." },
  "PAGE_ALREADY_OWNED_BY_OTHER_MERCHANT": {
    "message": "This account is already connected to another shop. Disconnect it there first."
  },
  "INVALID_CATEGORY_ID": { "message": "That product category isn't valid. Please pick another." },
  "FB_TOKEN_INVALID": { "message": "Your Facebook connection expired. Reconnect it in settings." },
  "IG_TOKEN_INVALID": { "message": "Your Instagram connection expired. Reconnect it in settings." },
  "FB_POLICY_BLOCKED": {
    "message": "The customer hasn't messaged in over 24 hours — they need to write first before you can reply"
  },
  "IG_POLICY_BLOCKED": {
    "message": "The customer hasn't messaged in over 24 hours — they need to write first before you can reply"
  },
  "FB_BAD_RESPONSE": { "message": "Facebook returned an unexpected response. Please try again." },
  "IG_BAD_RESPONSE": { "message": "Instagram returned an unexpected response. Please try again." },
  "LINE_API_ERROR": { "message": "The LINE API had a problem. Please try again." },
  "LINE_BAD_RESPONSE": { "message": "LINE returned an unexpected response. Please try again." },
  "LINE_QUOTA_EXHAUSTED": {
    "message": "You've used this month's LINE message quota. Upgrade your LINE plan to keep replying."
  },
  "TIKTOK_BAD_RESPONSE": { "message": "TikTok returned an unexpected response. Please try again." },
  "ALREADY_ACCEPTED": { "message": "That invitation has already been accepted" },
  "INVITATION_NOT_FOUND": { "message": "That invitation doesn't exist or has expired" },
  "INVITATION_ALREADY_CLAIMED": { "message": "That invitation has already been used" },
  "EMAIL_MISMATCH": { "message": "Your email doesn't match the invitation" },
  "USER_ALREADY_MEMBER": { "message": "You're already a member of this shop" },
  "SELF_INVITE": { "message": "You can't invite yourself" },
  "INVITE_COOLDOWN": { "message": "Please wait a moment before sending another invitation" },
  "SKU_INACTIVE": { "message": "This SKU is disabled" },
  "SKU_ALREADY_EXISTS": { "message": "That SKU already exists" },
  "ORDER_ALREADY_PAID": { "message": "This order has already been paid" },
  "INVALID_TRANSITION": { "message": "That status change isn't allowed" },
  "CONVERSATION_NOT_FOUND": { "message": "Conversation not found" },
  "CONVERSATION_CUSTOMER_MISMATCH": { "message": "This conversation doesn't match the selected customer" },
  "BOT_ACTION_EXPIRED": { "message": "This proposal has expired. Ask the bot to quote again." },
  "BOT_ACTION_NOT_PENDING": { "message": "This item has already been handled" },
  "BOT_ACTION_ALREADY_EXECUTED": { "message": "This order has already been approved" },
  "BOT_ACTION_NOT_FOUND": { "message": "The bot's proposal wasn't found (it may already have been handled)" },
  "BOT_ACTION_NO_CUSTOMER": { "message": "This item isn't linked to a customer, so no order can be created" },
  "AI_CONFIG_NOT_FOUND": { "message": "The AI assistant hasn't been set up yet" },
  "INSUFFICIENT_STOCK": { "message": "There isn't enough stock" },
  "POLICY_NOT_FOUND": { "message": "The policy you accepted wasn't found" },
  "EMAIL_PROVIDER_UNREACHABLE": { "message": "The email service is having trouble. Please try again." },
  "EMAIL_NOT_CONFIGURED": { "message": "The email service isn't ready yet" },
  "EMAIL_TOO_LARGE": { "message": "Something went wrong. Please try again." },
  "FALLBACK": { "message": "Something went wrong. Please try again." },
  "FORBIDDEN": { "message": "You don't have permission to do that" },
  "PRODUCT_NOT_FOUND": { "message": "Product not found" },
  "SKU_NOT_FOUND": { "message": "SKU not found" },
  "CUSTOMER_NOT_FOUND": { "message": "Customer not found" },
  "ORDER_NOT_FOUND": { "message": "Order not found" },
  "USER_NOT_FOUND": { "message": "User account not found" }
}
